import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { translateObject } from '../services/translationService';

/**
 * Hook that wraps React Query to auto-translate Firebase content
 * when language changes. Appends language to queryKey so React Query
 * caches per language automatically.
 */
export function useTranslatedQuery(baseQueryKey, fetchFn, translatableFields, options = {}) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return useQuery({
    queryKey: [...baseQueryKey, lang],
    queryFn: async () => {
      const data = await fetchFn();
      if (lang === 'de' || !data) return data;

      if (Array.isArray(data)) {
        return Promise.all(
          data.map(item => translateObject(item, translatableFields, lang))
        );
      }
      return translateObject(data, translatableFields, lang);
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
